import React from 'react';
import PropTypes from 'prop-types';
import {Map, List} from 'immutable';
import Button from 'sg/Button/Button.react';
import TwoWayRowColumn from './TwoWayRowColumn.react';
import SupplementManagerModalButton from 'client/Supplements/SupplementManager/SupplementManagerModalButton.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';
import AuthoringTextInput from 'client/EditPage/V2/AuthoringTextInput/AuthoringTextInput.react';

export default class TwoWayRow extends React.Component {
  static propTypes = {
    row: PropTypes.object,
    rowIndex: PropTypes.number,
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onBlur: PropTypes.func,
    onModelChange: PropTypes.func,
    validationErrors: PropTypes.instanceOf(Map)
  };

  removeRow = () => {
    const rows = this.props.question.getRows();

    const columnIds = List()
      .push(rows.getIn([this.props.rowIndex, 'columns', 'left', 'id']))
      .push(rows.getIn([this.props.rowIndex, 'columns', 'right', 'id']));
    const validResponse = this.props.question
      .getValidResponse()
      .filterNot((value, key) => columnIds.includes(key));
    const updatedRows = rows
      .remove(this.props.rowIndex)
      .sortBy((row) => row.get('index'))
      .map((row, index) => row.set('index', index));

    const updatedQuestion = this.props.question
      .setValidResponse(validResponse)
      .setRows(updatedRows);

    this.props.onModelChange(updatedQuestion, 'rows');
  };

  onStatementChange = (e) => {
    const rows = this.props.question
      .getRows()
      .setIn([this.props.rowIndex, 'statement'], e.target.value);

    const updatedQuestion = this.props.question.setRows(rows);
    this.props.onModelChange(updatedQuestion);
  };

  generateRowColumn(side) {
    const column = this.props.row.getIn(['columns', side]);

    return (
      <TwoWayRowColumn
        rowIndex={this.props.rowIndex}
        side={side}
        column={column}
        question={this.props.question}
        onBlur={this.props.onBlur}
        onModelChange={this.props.onModelChange}
      />
    );
  }

  render() {
    const rowError = this.props.validationErrors.getIn(['rubric', this.props.row.get('id')]);
    const fieldPath = `rows,${this.props.rowIndex},statement`;
    const isFirstRow = this.props.rowIndex === 0;
    return (
      <div className='two-way-editor__row-wrapper'>
        <div className='two-way-editor__row two-way-editor__row--nowrap'>
          {this.generateRowColumn('left')}
          {this.generateRowColumn('right')}
          <div className='two-way-editor__column two-way-editor__column--statement'>
            <div className='two-way-editor__row two-way-editor__row--statement-input two-way-editor__row-statement'>
              {isFirstRow ? <div className='a-form-input__label'>Row Prompt</div> : null}
              <AuthoringTextInput
                height='auto'
                value={this.props.row.get('statement')}
                onChange={this.onStatementChange}
                onBlur={this.props.onBlur}
                data-field-path={fieldPath}
                className='two-way-editor__row-statement-input'
                name='statement'
              />
              <SupplementManagerModalButton
                className='two-way-editor__add-supplement-btn two-way-editor__row-add-supplement-btn two-way-editor__row-add-supplement-btn--statement'
                color='blue'
                linkButton
                pathToProperty={fieldPath}
              />
            </div>
          </div>
          <div>
            {isFirstRow ? <div className='a-form-input__label'>&nbsp;</div> : null}
            <Button onClick={this.removeRow} className='fa fa-times' color='red' outline noBorder />
          </div>
        </div>
        {rowError ? <div className='a-form-input__error'>{rowError}</div> : null}
      </div>
    );
  }
}
